/**
 * Shared Axios instance (MSAL interceptors in utils/api).
 * Prefer domain modules (vacancyService, applicantService, menuService) for new code;
 * this export supports legacy call sites during incremental migration.
 */
import api from '../utils/api';

export default api;
export { api as httpClient };
